import { Box, Button, Card, FormInput, Icon, Title } from 'components'
import { useGetQuery, usePostQuery } from 'hooks'
import { useSocket, useStateValue } from 'providers'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Game, QuestionContainer, Answer, AnswersContainer } from './components'

export const GuestTriviaShow = () => {
  const [{ global }, dispatch] = useStateValue()
  const [state, setState] = useState({
    name: global.nickname,
    user: global.nickname
  })
  const [trivia, setTrivia] = useState()
  const [selection, setSelection] = useState()
  const [disabled, setDisabled] = useState('')
  const { id } = useParams()
  const socket = useSocket()

  useEffect(() => {
    // no-op if the socket is already connected
    socket.connect()

    return () => {
      socket.disconnect()
    }
  }, [])

  const handler = ({ target: { name, value } }) => {
    setState({ ...state, [name]: value })
  }

  const { data, error, isFetching, reFetch } = useGetQuery({
    url: `/activity/trivia/${id}`
  })

  const chooseAnswer = (a) => {
    selection === a ? setSelection() : setSelection(a)
    const result = socket.emit(`/trivia/${id}`, { answer: a, user: state.user })
  }

  const setUser = () => {
    setState({ user: state.name })
    dispatch({ type: 'SET_NICKNAME', nickname: state.name })
  }

  useEffect(() => {
    if (state.user) {
      const result = socket.emit(
        `/trivia/${id}`,
        {
          action: 'GUEST_JOINED',
          user: state.user
        },
        (f) => console.log(f, 'done')
      )
    }
  }, [state.user])

  useEffect(() => {
    if (!data) return
    const result = data?.queue?.QueueItems?.find((i) => i.state === 'active')
    setTrivia({
      ...result,
      answers: [
        ...result.details.incorrect_answers,
        result.details.correct_answer
      ]
    })
    socket.emit(`/trivia/${id}`, { user: state.user })
  }, [data])

  useEffect(() => {
    const channel = `/trivia/${id}`
    const handleSocketEvent = (res) => {
      if (res.answer || res.user || JSON.stringify(res) === '{}') return
      setDisabled('disabled')
      setTimeout(() => {
        setDisabled('')
        reFetch(true)
      }, 3000)
    }
    socket.on(channel, handleSocketEvent)
    return () => socket.off(channel, handleSocketEvent)
  }, [socket, trivia, id, reFetch])

  if (!state.user) {
    return (
      <Card>
        <FormInput
          label="What do we call you"
          name="name"
          value={state.name}
          onChange={handler}
        />
        <Button onPress={setUser}>Let's go!</Button>
      </Card>
    )
  }
  if (!trivia) return <div>Loading...</div>
  return (
    <Card padding="1rem">
      <Game>
        <QuestionContainer>
          <Title
            dangerouslySetInnerHTML={{ __html: trivia.details.question }}
          />
          <Box css="display: flex;align-items: center;justify-content: center;font-size: 5rem;">
            {disabled === 'disabled' &&
            trivia.details.correct_answer === selection
              ? '😄'
              : disabled === 'disabled'
                ? '🙁'
                : null}
          </Box>
          <AnswersContainer className={disabled}>
            {trivia.answers.map((a) => (
              <Answer
                key={a}
                onClick={() => chooseAnswer(a)}
                className={`${a === selection ? 'selected' : ''} ${
                  a === trivia.details.correct_answer ? 'correct' : 'incorrect'
                }`}
              >
                {' '}
                <span
                  dangerouslySetInnerHTML={{
                    __html: a
                  }}
                ></span>
                <>{a === selection ? <Icon icon="check" /> : null}</>
              </Answer>
            ))}
          </AnswersContainer>
        </QuestionContainer>
      </Game>
    </Card>
  )
}
